import { Cross } from "lucide-react";

const FooterComponent = () => {
  return (
    <footer className="py-12 px-4 custom-bg-color-03">
      <div className="max-w-4xl mx-auto text-center custom-color-01">
        <Cross className="w-8 h-8 mx-auto mb-4 opacity-60" />
        <p style={{ opacity: 0.8 }}>
          Congresso de Aconselhamento Bíblico Vida&Piedade 2025
        </p>
        <p className="text-sm mt-2" style={{ opacity: 0.6 }}>
          Em Cristo você pode mudar
        </p>
      </div>
    </footer>
  );
};
export default FooterComponent;
